import { render } from "./UserMedia.vue?vue&type=template&id=72833a0e"
import script from "./UserMedia.vue?vue&type=script&lang=js"
export * from "./UserMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__